module.exports = __webpack_public_path__ + "russierenouvelables/img/instagram.08765b8b.webp";